import { render } from "./FormActions.vue?vue&type=template&id=6d58aa9a&scoped=true&ts=true"
import script from "./FormActions.vue?vue&type=script&lang=ts"
export * from "./FormActions.vue?vue&type=script&lang=ts"

import "./form.scss?vue&type=style&index=0&id=6d58aa9a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d58aa9a"]])

export default __exports__